"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchPeriodIncomeStatement = exports.validateAskRequestCreate = exports.AskRequestPriorities = exports.AskRequestStatuses = exports.AskRequestTypes = void 0;
const commonUtil = __importStar(require("./commonUtil"));
const Errors_1 = require("./Errors");
const commonUtil_1 = require("./commonUtil");
const Links_1 = require("./Links");
exports.AskRequestTypes = {
    Ask_Bookkeeper: 'Ask Bookkeeper',
    Ask_Customer: 'Ask Customer',
    Flagged_Cell: 'Flagged Cell',
    Flagged_Report: 'Flagged Report',
    Customer_Request: 'Customer Request'
};
exports.AskRequestStatuses = {
    Open: 'Open',
    In_Progress: 'In Progress',
    Closed: 'Closed'
};
exports.AskRequestPriorities = {
    Blocker: 'Blocker',
    Normal: 'Normal'
};
function validateAskRequestCreate(toValidate, throwException = false) {
    // Any request requires these
    if (!toValidate ||
        !toValidate.locationId ||
        !toValidate.comment ||
        !toValidate.type) {
        return (0, Errors_1.falseOrThrow)(throwException, Errors_1.AskRequestErrors.invalidRequest);
    }
    // Check reportType
    const reportType = toValidate.reportType;
    if (reportType && !(0, Links_1.isReportType)(reportType)) {
        return (0, Errors_1.falseOrThrow)(throwException, () => Errors_1.AskRequestErrors.invalidReportType(reportType));
    }
    // Flagged cell requirements
    if (toValidate.type === exports.AskRequestTypes.Flagged_Cell) {
        if (!toValidate.identifier ||
            !toValidate.reportId ||
            !toValidate.period ||
            !(0, commonUtil_1.isValidNumber)(toValidate.flaggedAmount)) {
            return (0, Errors_1.falseOrThrow)(throwException, Errors_1.AskRequestErrors.invalidFlaggedCell);
        }
    }
    // Flagged report requirements
    if (toValidate.type === exports.AskRequestTypes.Flagged_Report) {
        if (!toValidate.reportId) {
            return (0, Errors_1.falseOrThrow)(throwException, Errors_1.AskRequestErrors.invalidFlaggedReport);
        }
    }
    // Flagged customer request requirements
    if (toValidate.type === exports.AskRequestTypes.Customer_Request) {
        if (!toValidate.identifier) {
            return (0, Errors_1.falseOrThrow)(throwException, Errors_1.AskRequestErrors.invalidCustomerRequest);
        }
    }
    // Flagged transaction requirements
    if (toValidate.type === exports.AskRequestTypes.Ask_Bookkeeper ||
        toValidate.type === exports.AskRequestTypes.Ask_Customer) {
        if (!toValidate.askTransaction ||
            !toValidate.period ||
            !toValidate.askTransaction.externalTransactionType ||
            !toValidate.askTransaction.externalId ||
            !(0, commonUtil_1.isValidNumber)(toValidate.flaggedAmount)) {
            return (0, Errors_1.falseOrThrow)(throwException, Errors_1.AskRequestErrors.invalidFlaggedTransaction);
        }
    }
    return true;
}
exports.validateAskRequestCreate = validateAskRequestCreate;
function matchPeriodIncomeStatement(toMatch, shortMonth, reportYear) {
    return toMatch.period === commonUtil.monthRangeFromShortMonth(shortMonth, reportYear).start;
}
exports.matchPeriodIncomeStatement = matchPeriodIncomeStatement;
//# sourceMappingURL=AskRequests.js.map